import { SettingsResolve } from './registry/settings.resolve';
import { AccountPaymentMethodsComponent } from './account-payment-methods/account-payment-methods.component';
import { HitchdCardsPaymentPageComponent } from './hitchd--cards-payment-page/hitchd-cards-payment-page.component';
import { RegLayoutPopupComponent } from './reg-layout-popup/reg-layout-popup.component';
import { RegIntroPopupComponent } from './reg-intro-popup/reg-intro-popup.component';
import { RegWelcomePopupComponent } from './reg-welcome-popup/reg-welcome-popup.component';
import { HitchdPaymentPageComponent } from './hitchd-payment-page/hitchd-payment-page.component';

import { StripeSuccessPopupComponent } from './stripe-success-popup/stripe-success-popup.component';
import { GuestModePopupComponent } from './guest-mode-popup/guest-mode-popup.component';
import { UserResolve } from './user/user.resolve';
import { WelcomePopupComponent } from './welcome-popup/welcome-popup.component';
import { GiftsResolve } from './registry/gifts.resolve';
import { UserLoggedInResolve } from './user/user-logged-in.resolve';
import { StripeGuideComponent } from './stripe-guide/stripe-guide.component';
import { RegistryResolve } from './registry/registry.resolve';
import { BannerComponent } from './banner/banner.component';
import { ToastComponent } from './toast/toast.component';
import { AccountShareComponent } from './account-share/account-share.component';
import { SigninComponent } from './signin/signin.component';
import { Routes, RouterModule } from '@angular/router';
import { GiftWishComponent } from './gift-wish/gift-wish.component';
import { GiftDetailComponent } from './gift-detail/gift-detail.component';
import { RegistryComponent } from './registry/registry.component';
import { GiftDescriptionComponent } from './gift-description/gift-description.component';
import { GiftPaymentComponent } from './gift-payment/gift-payment.component';
import { CreateGiftComponent } from './create-gift/create-gift.component';
import { TrackComponent } from './track/track.component';
import { AccountPersonalComponent } from './account-personal/account-personal.component';
import { AccountNotificationsComponent } from './account-notifications/account-notifications.component';
import { AccountPaymentComponent } from './account-payment/account-payment.component';
import { AccountFeesComponent } from './account-fees/account-fees.component';
import { GetStartedComponent } from './get-started/get-started.component';
import { HeaderBackgroundPopupComponent } from './header-background-popup/header-background-popup.component';
import { AuthGuard } from './guards/auth.guard';
import { TrackDetailComponent } from './track-detail/track-detail.component';
import { Registry404Component } from './registry404/registry404.component';
import { PageNotFound404Component } from './404/404.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { ContributionsResolve } from './registry/contributions.resolve';

import { RegFontPopupComponent } from './reg-font-popup/reg-font-popup.component';
import { ContributionSuccessPopupComponent } from './contribution-success-popup/contribution-success-popup.component';
import { ThankYouComponent } from './thank-you/thank-you.component';
import { AccountDeleteComponent } from './account-delete/account-delete.component';
import { AccountReferralComponent } from './account-referral/account-referral.component';
import {  TemplateComponent } from './templates/templates.component';
import { GuestCardsComponent } from './guest-cards/guest-cards.component';
import { RegColoursPopupComponent } from './reg-colours-popup/reg-colours-popup.component';
import { RegShapePopupComponent } from './reg-shape-popup/reg-shape-popup.component';
import { RegImageCropPopupComponent } from './reg-image-crop/reg-image-crop-popup.component';
import { RegSetupPopupComponent } from './reg-setup/reg-setup-popup.component';
import { MiniThanksComponent } from './mini-thanks/mini-thanks.component';
import { WebsiteBuilderComponent } from './website-builder/website-builder.component';
import { WebsiteComponent } from './website/website.component';
import { GuestListComponent } from './guest-list/guest-list.component';
import { OverviewComponent } from './overview/overview.component';
import { OverviewSettingsComponent } from './overview-settings/overview-settings.component';
import { TranslationSettingsComponent } from './translation-settings/translation-settings.component';
import { WebsiteResolve } from './website/website.resolve';
import { VisibilitySettingsComponent } from './visibility-settings/visibility-settings.component';
import { LandingComponent } from './landing/landing.component';
import { GuestsResolve } from './guest-list/guests.resolve';
import { PaymentPopupComponent } from './payment-popup/payment-popup.component';
import { MerchantComponent } from './merchant/merchant.component';

import { CreditCardSetupComponent } from './credit-card-setup/credit-card-setup.component';
import { MerchantResolve } from './merchant/merchant.resolve';
import { GiftCreditCardComponent } from './gift-creditcard/gift-creditcard.component';
// {
//   path: '', component: HeaderBackgroundPopupComponent, outlet: 'dialog'
//   , canActivate: [PathGuard], data: {
//     lockToPath: '/registry'
//   }
// },

export const routes: Routes = [
  {
    path: '', component: BannerComponent, outlet: 'banners',
    resolve: {
      registry: RegistryResolve,
      isLoggedIn: UserLoggedInResolve,
      gifts: GiftsResolve
    }

  },
 
  { path: '', component: ToastComponent, outlet: 'toast', 
  resolve: {
    registry: RegistryResolve,
    isLoggedIn: UserLoggedInResolve,
   
  } },
  { path: '', component: HeaderBackgroundPopupComponent, outlet: 'dialog' },
  {
    path: '', component: WelcomePopupComponent, outlet: 'tour', data: {
      pageUserMode: 'couple'
    }, resolve: {
      user: UserResolve,
      // registry: RegistryResolve
    }
  },
  {
    path: '', component: RegIntroPopupComponent, outlet: 'reg-intro', data: {
      pageUserMode: 'couple'
    }, resolve: {
      user: UserResolve,
      registry: RegistryResolve,
      settings: SettingsResolve
    }
  },
  {
    path: '', component: RegColoursPopupComponent, outlet: 'reg-colours', data: {
      pageUserMode: 'couple'
    }, resolve: {
      user: UserResolve,
      registry: RegistryResolve
    }
  },
  {
    path: '', component: RegShapePopupComponent, outlet: 'reg-shape', data: {
      pageUserMode: 'couple'
    }, resolve: {
      user: UserResolve,
      registry: RegistryResolve
    }
  },
  {
    path: '', component: RegWelcomePopupComponent, outlet: 'reg-welcome', data: {
      pageUserMode: 'couple'
    }, resolve: {
      user: UserResolve,
      registry: RegistryResolve
    }
  },
  {
    path: '', component: ContributionSuccessPopupComponent, outlet: 'contribution-success', data: {
      pageUserMode: 'guest'
    }, resolve: {
      user: UserResolve,
      registry: RegistryResolve,
      isLoggedIn: UserLoggedInResolve,
    }
  },
  {
    path: '', component: RegLayoutPopupComponent, outlet: 'reg-layout', data: {
      pageUserMode: 'couple'
    }, resolve: {
      user: UserResolve,
      registry: RegistryResolve
    }
  },
  {
    path: '', component: RegFontPopupComponent, outlet: 'reg-font', data: {
      pageUserMode: 'couple'
    }, resolve: {
      user: UserResolve,
      registry: RegistryResolve
    }
  },
  {
    path: '', component: RegImageCropPopupComponent, outlet: 'reg-image-crop', data: {
      pageUserMode: 'couple'
    }, resolve: {
      user: UserResolve,
      registry: RegistryResolve
    }
  },
  {
    path: '', component: GuestModePopupComponent, outlet: 'guest-popup', data: {
      pageUserMode: 'guest'
    }, resolve: {
    }
  }, 
  {
    path: '', component: StripeSuccessPopupComponent, outlet: 'stripe-success', data: {
      pageUserMode: 'couple'
    }, resolve: {
      user: UserResolve,
      registry: RegistryResolve
    },
  },
  {
    path: '', component: AccountShareComponent, outlet: 'share', data: {
      pageUserMode: 'couple'
    }, resolve: {
      user: UserResolve,
      // registry: RegistryResolve
    },

  },
  {
    path: '', component: AccountReferralComponent, outlet: 'referral', data: {
      pageUserMode: 'couple'
    }, resolve: {
      user: UserResolve,
      // registry: RegistryResolve
    },

  },
  {
    path: ':registry/registry', component: RegistryComponent,
    data: { header: 'registry', isLoggedIn: false },
    resolve: {
      registry: RegistryResolve,
      isLoggedIn: UserLoggedInResolve,
      gifts: GiftsResolve,
      user: UserResolve,
      settings: SettingsResolve,
      
    }
  },
  {
    path: ':registry/registry/contribution-success', component: RegistryComponent,
    data: { header: 'registry',       pageUserMode: 'guest'  , isLoggedIn: false },
    resolve: {
      registry: RegistryResolve,
      gifts: GiftsResolve,
    }
  },
  {
    path: ':registry/registry/:gifttitle', component: GiftDetailComponent,
    resolve: {
      registry: RegistryResolve,
      isLoggedIn: UserLoggedInResolve,
      gifts: GiftsResolve
    },
    data: { showControls: true, createMode: false, showGiftInfo: false, mode: 'description', isLoggedIn: false },

    children: [
      {
        path: '', component: GiftDescriptionComponent,
        resolve: {
          registry: RegistryResolve,
          isLoggedIn: UserLoggedInResolve,
          gifts: GiftsResolve
        },
      },
    ]
  },

  {
    path: ':registry/registry/:gifttitle/contribute', component: GiftPaymentComponent,
    resolve: {
      registry: RegistryResolve,
      isLoggedIn: UserLoggedInResolve,
      gifts: GiftsResolve
    },
    data: { showControls: false, createMode: false, showGiftInfo: true, mode: 'pay', isLoggedIn: false },
   
  },


  {
  
    path: ':registry/registry/:gifttitle', component: GiftDetailComponent,
    resolve: {
      registry: RegistryResolve,
      isLoggedIn: UserLoggedInResolve,
      gifts: GiftsResolve
    },
    data: { showControls: false, createMode: false, showGiftInfo: true, mode: 'wish', isLoggedIn: false },
    children: [

      {
        path: 'wish', component: GiftWishComponent,
        resolve: {
          registry: RegistryResolve,
          isLoggedIn: UserLoggedInResolve,
          gifts: GiftsResolve
        },
      }
    ]
  },
  {
    path: 'setup', component: RegSetupPopupComponent, outlet: '', data: {
      pageUserMode: 'couple'
    }, resolve: {
      user: UserResolve,
      registry: RegistryResolve,
      website: WebsiteResolve ,
      settings: SettingsResolve
    }
  },

  {
    path: 'registry', component: RegistryComponent, data: { header: 'registry', pageUserMode: 'couple' }, canActivate: [AuthGuard],
    resolve: {
      registry: RegistryResolve,
      isLoggedIn: UserLoggedInResolve,
      gifts: GiftsResolve,
      settings: SettingsResolve,
      user: UserResolve,
      contributions: ContributionsResolve
    }
  },
  {
    path: 'registry/payment', component: PaymentPopupComponent, data: { header: 'registry', pageUserMode: 'couple' }, canActivate: [AuthGuard],
    resolve: {
      registry: RegistryResolve,
      website: WebsiteResolve,
      settings: SettingsResolve,
      isLoggedIn: UserLoggedInResolve,
      gifts: GiftsResolve,
      user: UserResolve,
      contributions: ContributionsResolve,
      
    }
  },
  {
    path: 'visibility', component: VisibilitySettingsComponent, data: { header: 'registry', pageUserMode: 'couple' }, canActivate: [AuthGuard],
    resolve: {
      registry: RegistryResolve,
      website: WebsiteResolve,
      settings: SettingsResolve,
      isLoggedIn: UserLoggedInResolve,
      gifts: GiftsResolve,
      user: UserResolve,
      contributions: ContributionsResolve
    }
  },


  {
    path: 'settings', component: AccountPersonalComponent, data: { header: 'registry', pageUserMode: 'couple' }, canActivate: [AuthGuard],
    resolve: {
      registry: RegistryResolve,
      isLoggedIn: UserLoggedInResolve,
      gifts: GiftsResolve,
      user: UserResolve,
      contributions: ContributionsResolve,
      settings: SettingsResolve,
      website: WebsiteResolve
    }
  },
  {
    path: 'registry/thank-you-cards', component: HitchdCardsPaymentPageComponent
    , data: { mode: 'pay', pageUserMode: 'couple' }, canActivate: [AuthGuard],
    resolve: {
      registry: RegistryResolve,
      isLoggedIn: UserLoggedInResolve,
      user: UserResolve,
    }
  },
  {
    path: 'registry/payment', component: HitchdPaymentPageComponent
    , data: { mode: 'pay', pageUserMode: 'couple' }, canActivate: [AuthGuard],
    resolve: {
      registry: RegistryResolve,
      isLoggedIn: UserLoggedInResolve,
      user: UserResolve,
      gifts: GiftsResolve,
      settings: SettingsResolve,
      website: WebsiteResolve
    }
  }, {
    path: 'website/upgrade', component: HitchdPaymentPageComponent
    , data: { mode: 'upgrade', pageUserMode: 'couple' }, canActivate: [AuthGuard],
    resolve: {
      registry: RegistryResolve,
      isLoggedIn: UserLoggedInResolve,
      user: UserResolve,
      settings: SettingsResolve,
      website: WebsiteResolve
    }
  },

  {
    path: 'website/payment', component: HitchdPaymentPageComponent
    , data: { mode: 'pay', pageUserMode: 'couple' }, canActivate: [AuthGuard],
    resolve: {
      registry: RegistryResolve,
      isLoggedIn: UserLoggedInResolve,
      user: UserResolve,
      gifts: GiftsResolve,
      settings: SettingsResolve,
      website: WebsiteResolve
    }
  }, {
    path: 'registry/upgrade', component: HitchdPaymentPageComponent
    , data: { mode: 'upgrade', pageUserMode: 'couple' }, canActivate: [AuthGuard],
    resolve: {
      registry: RegistryResolve,
      isLoggedIn: UserLoggedInResolve,
      user: UserResolve,
      gifts: GiftsResolve,
      settings: SettingsResolve,
      website: WebsiteResolve
    }
  },




  {
    path: 'registry/templates/:sectionName', component: TemplateComponent
    , data: { pageUserMode: 'couple' }, canActivate: [AuthGuard],
    resolve: {
      registry: RegistryResolve,
      isLoggedIn: UserLoggedInResolve,
      user: UserResolve,
    }
  },

  {
    path: 'registry/templates', component: TemplateComponent
    , data: { pageUserMode: 'couple' }, canActivate: [AuthGuard],
    resolve: {
      registry: RegistryResolve,
      isLoggedIn: UserLoggedInResolve,
      user: UserResolve,
    }
  },
  {
    path: 'registry/how-contributions-work', component: RegistryComponent, data: { header: 'registry', pageUserMode: 'couple' }, canActivate: [AuthGuard],
    resolve: {
      registry: RegistryResolve,
      isLoggedIn: UserLoggedInResolve,
      gifts: GiftsResolve,
      user: UserResolve
    }
  },
  {
    path: 'registry/intro', component: RegistryComponent,
    data: { header: 'registry', pageUserMode: 'couple' }, canActivate: [AuthGuard],
    resolve: {
      registry: RegistryResolve,
      isLoggedIn: UserLoggedInResolve,
      gifts: GiftsResolve,
      user: UserResolve
    }
  },
  {
    path: 'registry/welcome', component: RegistryComponent,
    data: { header: 'registry', pageUserMode: 'couple' }, canActivate: [AuthGuard],
    resolve: {
      registry: RegistryResolve,
      isLoggedIn: UserLoggedInResolve,
      gifts: GiftsResolve,
      user: UserResolve
    }
  },
  {
    path: 'registry/font', component: RegistryComponent,
    data: { header: 'registry', pageUserMode: 'couple' }, canActivate: [AuthGuard],
    resolve: {
      registry: RegistryResolve,
      isLoggedIn: UserLoggedInResolve,
      gifts: GiftsResolve,
      user: UserResolve
    }
  },
  
  {
    path: 'registry/gift-templates', component: RegistryComponent,
    data: { header: 'registry', pageUserMode: 'couple' }, canActivate: [AuthGuard],
    resolve: {
      registry: RegistryResolve,
      isLoggedIn: UserLoggedInResolve,
      gifts: GiftsResolve,
      user: UserResolve
    }
  },
  {
    path: 'website', component: WebsiteComponent,
    data: { header: 'registry', pageUserMode: 'couple' }, canActivate: [AuthGuard],
    resolve: {
      registry: RegistryResolve,
      isLoggedIn: UserLoggedInResolve,
      gifts: GiftsResolve,
      user: UserResolve
    }
  },
  {
    path: 'website/preview', component: WebsiteComponent,
    data: { header: 'registry', pageUserMode: 'couple' }, canActivate: [AuthGuard],
    resolve: {
      registry: RegistryResolve,
      isLoggedIn: UserLoggedInResolve,
      gifts: GiftsResolve,
      user: UserResolve
    }
  },
  {
    path: 'website/builder/preview-template/:templateId', component: WebsiteComponent,
    data: { header: 'registry', pageUserMode: 'couple' }, canActivate: [AuthGuard],
    resolve: {
      registry: RegistryResolve,
      isLoggedIn: UserLoggedInResolve,
      gifts: GiftsResolve,
      user: UserResolve,
    }
  },
  {
    path: 'guest-list', component: GuestListComponent,
    data: { header: 'registry', pageUserMode: 'couple', guestListMode:'' }, canActivate: [AuthGuard],
    resolve: {
      registry: RegistryResolve,
      isLoggedIn: UserLoggedInResolve,
      gifts: GiftsResolve,
      website: WebsiteResolve,
      guests: GuestsResolve,
      user: UserResolve,
      settings: SettingsResolve
    }
  },
  {
    path: 'guest-list/add-event', component: GuestListComponent,
    data: { header: 'registry',  pageUserMode: 'couple', guestListMode:'add-event' }, canActivate: [AuthGuard],
    resolve: {
      registry: RegistryResolve,
      isLoggedIn: UserLoggedInResolve,
      gifts: GiftsResolve,
      website: WebsiteResolve,
      guests: GuestsResolve,
      user: UserResolve,
      settings: SettingsResolve
    }
  },
  {
    path: 'guest-list/bulk-upload', component: GuestListComponent,
    data: { header: 'registry',  pageUserMode: 'couple', guestListMode:'bulk-upload' }, canActivate: [AuthGuard],
    resolve: {
      registry: RegistryResolve,
      isLoggedIn: UserLoggedInResolve,
      gifts: GiftsResolve,
      user: UserResolve
    }
  },
  {
    path: 'guest-list/add-guest', component: GuestListComponent,
    data: { header: 'registry',  pageUserMode: 'couple', guestListMode:'add-guest' }, canActivate: [AuthGuard],
    resolve: {
      registry: RegistryResolve,
      isLoggedIn: UserLoggedInResolve,
      gifts: GiftsResolve,
      user: UserResolve
    }
  },
  {
    path: 'guest-list/:event/questions', component: GuestListComponent,
    data: { header: 'registry', pageUserMode: 'couple'  ,guestListMode:'add-question' }, canActivate: [AuthGuard],
    resolve: {
      registry: RegistryResolve,
      isLoggedIn: UserLoggedInResolve,
      gifts: GiftsResolve,
      user: UserResolve
    }
  },
  {
    path: 'guest-list/:event/edit', component: GuestListComponent,
    data: { header: 'registry',  pageUserMode: 'couple',guestListMode:'edit-event'  }, canActivate: [AuthGuard],
    resolve: {
      registry: RegistryResolve,
      isLoggedIn: UserLoggedInResolve,
      gifts: GiftsResolve,
      user: UserResolve
    }
  },

  {
    path: 'guest-list/:event', component: GuestListComponent,
    data: { header: 'registry',  pageUserMode: 'couple', guestListMode:'view-event' }, canActivate: [AuthGuard],
    resolve: {
      registry: RegistryResolve,
      isLoggedIn: UserLoggedInResolve,
      gifts: GiftsResolve,
      user: UserResolve
    }
  },

  {
    path: 'website/builder', component: WebsiteBuilderComponent,
    data: { header: 'registry', pageUserMode: 'couple' }, canActivate: [AuthGuard],
    resolve: {
      registry: RegistryResolve,
      isLoggedIn: UserLoggedInResolve,
      gifts: GiftsResolve,
      user: UserResolve,
      settings: SettingsResolve,
      website: WebsiteResolve,
      contributions: ContributionsResolve
    }
  },

  {
    path: 'website/builder/rsvp', component: WebsiteBuilderComponent,
    data: { header: 'registry', pageUserMode: 'couple' }, canActivate: [AuthGuard],
    resolve: {
      registry: RegistryResolve,
      isLoggedIn: UserLoggedInResolve,
      gifts: GiftsResolve,
      user: UserResolve,
      settings: SettingsResolve,
      website: WebsiteResolve,
      contributions: ContributionsResolve
    }
  },
  {
    path: 'website/builder/designs', component: WebsiteBuilderComponent,
    data: { header: 'registry', pageUserMode: 'couple' }, canActivate: [AuthGuard],
    resolve: {
      registry: RegistryResolve,
      isLoggedIn: UserLoggedInResolve,
      gifts: GiftsResolve,
      user: UserResolve,
      settings: SettingsResolve,
      website: WebsiteResolve,
      contributions: ContributionsResolve
    }
  },
  
  {
    path: 'website/builder/content', component: WebsiteBuilderComponent,
    data: { header: 'registry', pageUserMode: 'couple' }, canActivate: [AuthGuard],
    resolve: {
      registry: RegistryResolve,
      isLoggedIn: UserLoggedInResolve,
      gifts: GiftsResolve,
      user: UserResolve,
      settings: SettingsResolve,
      website: WebsiteResolve,
      contributions: ContributionsResolve
    }
  },
  {
    path: 'registry/layout', component: RegistryComponent,
    data: { header: 'registry', pageUserMode: 'couple' }, canActivate: [AuthGuard],
    resolve: {
      registry: RegistryResolve,
      isLoggedIn: UserLoggedInResolve,
      gifts: GiftsResolve,
      user: UserResolve
    }
  },
  {
    path: 'registry/fee-selection', component: RegistryComponent,
    data: { header: 'registry', pageUserMode: 'couple' }, canActivate: [AuthGuard],
    resolve: {
      registry: RegistryResolve,
      isLoggedIn: UserLoggedInResolve,
      gifts: GiftsResolve,
      user: UserResolve
    }
  },
  {
    path: 'registry/stripe-connected', component: RegistryComponent,
    data: { header: 'registry', pageUserMode: 'couple' }, canActivate: [AuthGuard],
    resolve: {
      registry: RegistryResolve,
      isLoggedIn: UserLoggedInResolve,
      gifts: GiftsResolve,
      user: UserResolve
    }
  },
  {
    path: 'website/builder/launched', component: WebsiteBuilderComponent,
    data: { header: 'registry', pageUserMode: 'couple' }, canActivate: [AuthGuard],
    resolve: {
      registry: RegistryResolve,
      isLoggedIn: UserLoggedInResolve,
      gifts: GiftsResolve,
      user: UserResolve,
      settings: SettingsResolve,
      website: WebsiteResolve,
      contributions: ContributionsResolve
    }
  },
  {
    path: 'registry/launched', component: RegistryComponent,
    data: { header: 'registry', pageUserMode: 'couple' }, canActivate: [AuthGuard],
    resolve: {
      registry: RegistryResolve,
      isLoggedIn: UserLoggedInResolve,
      gifts: GiftsResolve,
      user: UserResolve
    }
  },
  {
    path: 'registry/publish', component: AccountPaymentComponent,
    data: { header: 'registry', pageUserMode: 'couple' }, canActivate: [AuthGuard],
    resolve: {
      registry: RegistryResolve,
      isLoggedIn: UserLoggedInResolve,
      gifts: GiftsResolve,
      user: UserResolve
    }
  },
  {
    path: 'registry/credit-card-test', component: GiftCreditCardComponent,
    data: { header: 'registry', pageUserMode: 'couple' }, canActivate: [AuthGuard],
    resolve: {
      registry: RegistryResolve,
      isLoggedIn: UserLoggedInResolve,
      gifts: GiftsResolve,
      settings: SettingsResolve,
      user: UserResolve,
      contributions: ContributionsResolve
    }
  },

  {
    path: 'registry/add-payment-methods/credit-card',
    component: CreditCardSetupComponent,
    data: { header: 'registry', pageUserMode: 'couple', step: 1 }, 
    canActivate: [AuthGuard],
    resolve: {
      registry: RegistryResolve,
      isLoggedIn: UserLoggedInResolve,
      gifts: GiftsResolve,
      settings: SettingsResolve,
      user: UserResolve,
      contributions: ContributionsResolve,
      merchant: MerchantResolve
    },
    children: [
      {
        path: 'add',
        component: MerchantComponent,
        canActivate: [AuthGuard],
        resolve: {
          merchant: MerchantResolve
        }
      },
      {
        path: 'update',
        component: MerchantComponent,
        canActivate: [AuthGuard],
        resolve: {
          merchant: MerchantResolve
        }
      }
    ]
  },
  {
    path: 'registry/add-payment-methods/credit-card/add',
    component: CreditCardSetupComponent,
    data: { header: 'registry', pageUserMode: 'couple', step: 1 }, canActivate: [AuthGuard],
    resolve: {
      registry: RegistryResolve,
      isLoggedIn: UserLoggedInResolve,
      gifts: GiftsResolve,
      settings: SettingsResolve,
      user: UserResolve,
      contributions: ContributionsResolve
    }
  },
  {
    path: 'registry/add-payment-methods/credit-card/update',
    component: CreditCardSetupComponent,
    data: { header: 'registry', pageUserMode: 'couple', step: 1 }, canActivate: [AuthGuard],
    resolve: {
      registry: RegistryResolve,
      isLoggedIn: UserLoggedInResolve,
      gifts: GiftsResolve,
      settings: SettingsResolve,
      user: UserResolve,
      contributions: ContributionsResolve
    }
  },
  {
    path: 'registry/add-payment-methods', component: AccountPaymentMethodsComponent,
    data: { header: 'registry', pageUserMode: 'couple', step: 1 }, canActivate: [AuthGuard],
    resolve: {
      registry: RegistryResolve,
      isLoggedIn: UserLoggedInResolve,
      gifts: GiftsResolve,
      settings: SettingsResolve,
      user: UserResolve,
      contributions: ContributionsResolve
    }
  },
  {
    path: 'registry/publish/step-1', component: AccountPaymentComponent,
    data: { header: 'registry', pageUserMode: 'couple', step: 1 }, canActivate: [AuthGuard],
    resolve: {
      registry: RegistryResolve,
      isLoggedIn: UserLoggedInResolve,
      gifts: GiftsResolve,
      settings: SettingsResolve,
      user: UserResolve,
      contributions: ContributionsResolve
    }
  },
  {
    path: 'registry/mini-thanks', component: MiniThanksComponent,
    data: { header: 'registry', pageUserMode: 'couple', step: 1 }, canActivate: [AuthGuard],
    resolve: {
      registry: RegistryResolve,
      isLoggedIn: UserLoggedInResolve,   
      user: UserResolve,
      settings: SettingsResolve,
    }
  },
  {
    path: 'registry/publish/step-2', component: AccountPaymentComponent,
    data: { header: 'registry', pageUserMode: 'couple', step: 2 }, canActivate: [AuthGuard],
    resolve: {
      registry: RegistryResolve,
      isLoggedIn: UserLoggedInResolve,
      gifts: GiftsResolve,
      settings: SettingsResolve,
      user: UserResolve,
      contributions: ContributionsResolve
    }
  },
  {
    path: 'registry/publish/step-3', component: AccountPaymentComponent,
    data: { header: 'registry', pageUserMode: 'couple', step: 3 }, canActivate: [AuthGuard],
    resolve: {
      registry: RegistryResolve,
      isLoggedIn: UserLoggedInResolve,
      gifts: GiftsResolve,
      settings: SettingsResolve,
      user: UserResolve,
      contributions: ContributionsResolve
    }
  },
  {
    path: 'registry/share', component: RegistryComponent,
    data: { header: 'registry', pageUserMode: 'couple' }, canActivate: [AuthGuard],
    resolve: {
      registry: RegistryResolve,
      isLoggedIn: UserLoggedInResolve,
      gifts: GiftsResolve,
      user: UserResolve
    }
  },
  {
    path: 'signup', component: GetStartedComponent,
  },
  {
    path: 'registry/thank/:paymentId', component: ThankYouComponent, canActivate: [AuthGuard],
    data: { focus: true, pageUserMode: 'couple' },
    resolve: {
      gifts: GiftsResolve,
      contributions: ContributionsResolve
    }
  },
  {
    path: 'registry/contributions/:paymentId', component: TrackDetailComponent, canActivate: [AuthGuard],
    data: { focus: true, pageUserMode: 'couple' },
    resolve: {
      gifts: GiftsResolve,
      contributions: ContributionsResolve
    }
  },
  {
    path: 'registry/contributions', component: TrackComponent, canActivate: [AuthGuard],
    data: { focus: true, pageUserMode: 'couple' },
    resolve: {
      gifts: GiftsResolve,
      contributions: ContributionsResolve,
      settings: SettingsResolve
    }
  },
  
  {
    path: 'registry/settings', component: AccountPersonalComponent, canActivate: [AuthGuard],
    data: { focus: true, pageUserMode: 'couple' },
    resolve: {
      gifts: GiftsResolve,
      contributions: ContributionsResolve,
      registry: RegistryResolve,
      settings: SettingsResolve
    }
  },
  {
    path: 'settings/intro', component: AccountPersonalComponent
    , data: { focus: true, pageUserMode: 'couple' },
    resolve: {
      gifts: GiftsResolve,
      contributions: ContributionsResolve
    }
  },
  {
    path: 'settings/notifications', component: AccountNotificationsComponent
    , data: { focus: true, pageUserMode: 'couple' },
    resolve: {
      gifts: GiftsResolve,
      contributions: ContributionsResolve,
      registry: RegistryResolve,
      settings: SettingsResolve,
    }
  },
  {
    path: 'settings/translations', component: TranslationSettingsComponent
    , data: { focus: true, pageUserMode: 'couple' },
    resolve: {
    
      
    }
  },
  {
    path: 'registry/publish', component: AccountPaymentComponent, canActivate: [AuthGuard],
    data: { focus: true, pageUserMode: 'couple' },
    resolve: {
      gifts: GiftsResolve,
      contributions: ContributionsResolve,

    }
  },
  {
    path: 'registry/publish', component: AccountPaymentComponent, canActivate: [AuthGuard],
    data: { focus: true, pageUserMode: 'couple' },
    resolve: {
      gifts: GiftsResolve,
      contributions: ContributionsResolve
    }
  },
  {
    path: 'publish/live', component: AccountPaymentComponent, canActivate: [AuthGuard],
    data: { focus: true, pageUserMode: 'couple' },
    resolve: {
      gifts: GiftsResolve,
      contributions: ContributionsResolve
    }
  },
  {
    path: 'settings/fees', component: AccountFeesComponent, canActivate: [AuthGuard],
    data: { focus: true, pageUserMode: 'couple' },
    resolve: {
      gifts: GiftsResolve,
      registry: RegistryResolve,
      contributions: ContributionsResolve
    }
  },
  {
    path: 'settings/close', component: AccountDeleteComponent, canActivate: [AuthGuard],
    data: { focus: true, pageUserMode: 'couple' },
    resolve: {
      gifts: GiftsResolve,
      registry: RegistryResolve,
      contributions: ContributionsResolve
    }
  },
  { path: 'stripe-guide', component: StripeGuideComponent, canActivate: [AuthGuard] },
  {
    path: 'registry/create-gift/:sectionName', component: CreateGiftComponent, data: { showPopup: false, pageUserMode: 'couple' },
    resolve: {
      registry: RegistryResolve,
      isLoggedIn: UserLoggedInResolve,
     gifts: GiftsResolve,
      user: UserResolve,
      settings: SettingsResolve
    }
    
  },
  {
    path: 'registry/create-gift', component: CreateGiftComponent, data: { showPopup: false, pageUserMode: 'couple' },
    resolve: {
      registry: RegistryResolve,
      isLoggedIn: UserLoggedInResolve,
     gifts: GiftsResolve,
      user: UserResolve,
      settings: SettingsResolve
    }
    
  },
  {
    path: 'registry/:gifttitle/edit', component: CreateGiftComponent, data: { showPopup: false, pageUserMode: 'couple' },
    resolve: {
      registry: RegistryResolve,
      isLoggedIn: UserLoggedInResolve,
      gifts: GiftsResolve,
      user: UserResolve,
      settings: SettingsResolve
    }
    , canActivate: [AuthGuard]
  },
  {
    path: 'registry', component: CreateGiftComponent, data: { showControls: false, createMode: true, mode: 'create-help' },
    resolve: {
      registry: RegistryResolve,
      isLoggedIn: UserLoggedInResolve,
      gifts: GiftsResolve,
      user: UserResolve
    },
    children: [
      { path: 'create-gift/help/:step', component: CreateGiftComponent, data: { showPopup: true, pageUserMode: 'couple' } },

    ], canActivate: [AuthGuard]
  },

  {
    path: 'registry/:gifttitle', component: GiftDetailComponent,
    data: { showControls: true, createMode: false, showGiftInfo: false, mode: 'description', pageUserMode: 'couple' },
    resolve: {
      registry: RegistryResolve,
      isLoggedIn: UserLoggedInResolve,
      gifts: GiftsResolve
    },
    children: [
      {
        data: { pageUserMode: 'couple' },
        path: '', component: GiftDescriptionComponent,
        resolve: {
          registry: RegistryResolve,
          isLoggedIn: UserLoggedInResolve,
          gifts: GiftsResolve
        },
      },
    ]
    , canActivate: [AuthGuard]
  },
  {
    path: 'registry/:gifttitle/contribute', component: GiftPaymentComponent,
    data: { showControls: false, createMode: false, showGiftInfo: true, mode: 'pay', pageUserMode: 'couple' },
    resolve: {
      registry: RegistryResolve,
      isLoggedIn: UserLoggedInResolve,
      gifts: GiftsResolve
    },
  },
   

  {
    path: 'registry/:gifttitle', component: GiftDetailComponent,
    data: { showControls: false, createMode: false, showGiftInfo: true, mode: 'wish', pageUserMode: 'couple' },
    resolve: {
      registry: RegistryResolve,
      isLoggedIn: UserLoggedInResolve,
      gifts: GiftsResolve
    },
    children: [
      {
        data: { pageUserMode: 'couple' },
        path: 'wish', component: GiftWishComponent,
        resolve: {
          registry: RegistryResolve,
          isLoggedIn: UserLoggedInResolve,
          gifts: GiftsResolve
        },
      }
    ]
    , canActivate: [AuthGuard]
  },
  {
    path: 'create-registry', component: TemplateComponent
    , data: { pageUserMode: 'couple_anon' }, canActivate: [],
    resolve: {
      
    
      
    }
  },   
  {
    path: 'your-registry/contributions', component: TrackComponent,
        data: { focus: true, pageUserMode: 'couple_anon' },
    resolve: {
   
    }
  }, 
  {
    path: 'your-registry/add-payment-methods', component: AccountPaymentMethodsComponent,
    data: { header: 'registry', pageUserMode: 'couple', step: 1 },
    resolve: {
      
      
      
      
    }
  },

  {
    path: 'create-custom-gift', component: CreateGiftComponent, data: { showPopup: false, pageUserMode: 'couple_anon' },
    resolve: {
  
    }
    
  },
  {
    path: 'your-registry/:gifttitle/edit', component: CreateGiftComponent, data: { showPopup: false, pageUserMode: 'couple_anon' },
    resolve: {
   
    }

  },
  {
    path: 'overview/launched', component: OverviewComponent    , data: { mode: 'upgrade', pageUserMode: 'couple' }, canActivate: [AuthGuard],
    resolve: {
      registry: RegistryResolve,
      website: WebsiteResolve,
      isLoggedIn: UserLoggedInResolve,
      user: UserResolve,
      gifts: GiftsResolve,
      contributions: ContributionsResolve
      
    }
  },
  {
    path: 'overview', component: OverviewComponent    , data: { mode: 'upgrade', pageUserMode: 'couple' }, canActivate: [AuthGuard],
    resolve: {
      registry: RegistryResolve,
      website: WebsiteResolve,
      isLoggedIn: UserLoggedInResolve,
      user: UserResolve,
      gifts: GiftsResolve,
      contributions: ContributionsResolve
      
    }
  },

  { path: 'login', component: SigninComponent },
  { path: 'forgot-password', component: ForgotPasswordComponent },

  {
    path: 'login/verified', component: SigninComponent, data: {
      verified: true
    }
  },
  { path: '404', component: PageNotFound404Component },
  { path: 'coming-soon', component: Registry404Component },
  {
    path: ':registry', component: LandingComponent,
    data: { header: 'registry', isLoggedIn: false },
    resolve: {
      registry: RegistryResolve,
      
      gifts: GiftsResolve,
      
      settings: SettingsResolve,
      website: WebsiteResolve
    }
  },
  // {
  //   path: ':registry/registry', component: RegistryComponent,
  //   data: { header: 'registry', isLoggedIn: false },
  //   resolve: {
  //     registry: RegistryResolve,
  //     isLoggedIn: UserLoggedInResolve,
  //     gifts: GiftsResolve,
  //     user: UserResolve,
  //     settings: SettingsResolve,
      
  //   }
  // },
  {
    path: ':registry', component: GuestModePopupComponent, outlet: '  guest-popup', data: {
      pageUserMode: 'guest'
    }, resolve: {
    }
  },
  {
    path: ':registry/contribution-success', component: RegistryComponent,
    data: { header: 'registry' ,      pageUserMode: 'guest', isLoggedIn: false  },
    resolve: {
      registry: RegistryResolve,
      gifts: GiftsResolve,
    }
  },

  {
    path: ':registry/help/about-hitchd', component: RegistryComponent,
    data: { header: 'registry', isLoggedIn: false },
    resolve: {
      registry: RegistryResolve,
      isLoggedIn: UserLoggedInResolve,
      gifts: GiftsResolve,
      user: UserResolve
    }
  },
  {
    path: ':registry/help/how-it-works', component: RegistryComponent,
    data: { header: 'registry', isLoggedIn: false },
    resolve: {
      registry: RegistryResolve,
      isLoggedIn: UserLoggedInResolve,
      gifts: GiftsResolve,
      user: UserResolve
    }
  },
  {
    path: ':registry/welcome', component: RegistryComponent,
    data: { header: 'registry', pageUserMode: 'couple' },
    resolve: {
      registry: RegistryResolve,
      isLoggedIn: UserLoggedInResolve,
       
    }
  },

  {
    path: ':registry/:gifttitle', component: GiftDetailComponent,
    resolve: {
      registry: RegistryResolve,
      isLoggedIn: UserLoggedInResolve,
      gifts: GiftsResolve
    },
    data: { showControls: true, createMode: false, showGiftInfo: false, mode: 'description', isLoggedIn: false },

    children: [
      {
        path: '', component: GiftDescriptionComponent,
        resolve: {
          registry: RegistryResolve,
          isLoggedIn: UserLoggedInResolve,
          gifts: GiftsResolve
        },
      },
    ]
  },

  {
    path: ':registry/:gifttitle/contribute', component: GiftPaymentComponent,
    resolve: {
      registry: RegistryResolve,
      isLoggedIn: UserLoggedInResolve,
      gifts: GiftsResolve
    },
    data: { showControls: false, createMode: false, showGiftInfo: true, mode: 'pay', isLoggedIn: false },
   
  },

  {
    path: ':registry/wellwishes/:contributionId', component: GuestCardsComponent,
    resolve: {
    },
    data: { showControls: false, createMode: false, showGiftInfo: true, mode: 'wish', isLoggedIn: false },
   
  },  
  {
    path: ':registry/wellwishes/:contributionId/send', component: GuestCardsComponent,
    resolve: {
    },
    data: { showControls: false, createMode: false, showGiftInfo: true, mode: 'wish', isLoggedIn: false },
   
  },
 
  {
  
    path: ':registry/:gifttitle', component: GiftDetailComponent,
    resolve: {
      registry: RegistryResolve,
      isLoggedIn: UserLoggedInResolve,
      gifts: GiftsResolve
    },
    data: { showControls: false, createMode: false, showGiftInfo: true, mode: 'wish', isLoggedIn: false },
    children: [

      {
        path: 'wish', component: GiftWishComponent,
        resolve: {
          registry: RegistryResolve,
          isLoggedIn: UserLoggedInResolve,
          gifts: GiftsResolve
        },
      }
    ]
  },

  {
    path: 'registry',
    component: RegistryComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'add-payment-methods/credit-card',
        component: CreditCardSetupComponent,
        children: [
          {
            path: 'add',
            component: MerchantComponent,
            canActivate: [AuthGuard]
          },
          {
            path: 'update',
            component: MerchantComponent,
            canActivate: [AuthGuard]
          }
        ]
      }
    ]
  }
];



export const appRoutes = RouterModule.forRoot(routes);



// WEBPACK FOOTER //
// ./src/app/app.routing.ts